import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { ModerationService } from 'src/app/services/moderation.service';
import * as Excel from 'exceljs';
import { buffer } from 'rxjs/operators';
import * as FileSaver from 'file-saver';
import { ContenusService } from 'src/app/services/contenus.service';
import { EncryptionService } from 'src/app/services/encryption.service';
@Component({
  selector: 'app-excel',
  templateUrl: './excel.component.html',
  styleUrls: ['./excel.component.css']
})
export class ExcelComponent implements OnInit {

  file : File
  arrayBuffer: any;

  constructor(private moderationService: ModerationService, private contenuService : ContenusService, private encryptService:EncryptionService ) { }

  ngOnInit(): void {
  }

  convertToJSONbyCellRef(event) {
    let arrayOut = [];
    this.file = event.files[0];
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.file);

    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      let data = new Uint8Array(this.arrayBuffer);
      let arr = new Array();

      for(let i = 0; i != data.length; i++) arr[i] = String.fromCharCode(data[i]);

      let bstr = arr.join("");
      let workbook = XLSX.read(bstr, {type: "binary", cellDates:true, dateNF:"dd/mm/yyyy HH:MM:SS;@"});
      
      let firstSheetName = workbook.SheetNames[0];
      var workSheet = workbook.Sheets[firstSheetName]; 

      // var range = XLSX.utils.decode_range(workSheet['!ref']);
      // console.log(range)
      let jsonOutput = XLSX.utils.sheet_to_json(workSheet, {raw: false, defval:""});
      let arrayOut = [];
      for(let i:number=2; i < (jsonOutput.length + 2); i++) {
        let infoPtl = {
          "date_saisie": "",
          "numero_convention": "",
          "login": null,
          "id_shop": "",
          "produit": "",
          "enseigne_postale": "",
          "activite_principale": "",
          "enseigne_guide": "",
          "adresse": "",
          "numero_voie": "",
          "complement_adresse": "",
          "bp": "",
          "code_postal": null,
          "ville": "",
          "pays": "",
          "email": "",
          "telephone_fixe": "",
          "telephone_portable": "",
          "canal_vente": ""
        };

        let contenu = {
          "logo": {},
          "site_internet": {},
          "reseaux_sociaux": [],
          "photo": [],
          "description":""
        };

        infoPtl.date_saisie = (workSheet[("A" + i)]) ? workSheet[("A" + i)]["w"] : "";
        infoPtl.login = (workSheet[("C" + i)]) ? parseInt(workSheet[("C" + i)]["w"]) : null;
        infoPtl.numero_convention = (workSheet[("B" + i)]) ? workSheet[("B" + i)]["w"] : "";
        infoPtl.id_shop = (workSheet[("D" + i)]) ? workSheet[("D" + i)]["w"] : "";
        infoPtl.produit = (workSheet[("E" + i)]) ? workSheet[("E" + i)]["w"] : "";
        infoPtl.enseigne_postale = (workSheet[("F" + i)]) ? workSheet[("F" + i)]["w"] : "";
        infoPtl.activite_principale = (workSheet[("G" + i)]) ? workSheet[("G" + i)]["w"] : "";
        infoPtl.enseigne_guide = (workSheet[("H" + i)]) ? workSheet[("H" + i)]["w"] : "";
        infoPtl.adresse = (workSheet[("I" + i)]) ? workSheet[("I" + i)]["w"] : "";
        infoPtl.numero_voie = (workSheet[("J" + i)]) ? workSheet[("J" + i)]["w"] : "";
        infoPtl.complement_adresse = (workSheet[("K" + i)]) ? workSheet[("K" + i)]["w"] : "";
        infoPtl.bp = (workSheet[("L" + i)]) ? workSheet[("L" + i)]["w"] : "";
        infoPtl.code_postal = (workSheet[("M" + i)]) ? parseInt(workSheet[("M" + i)]["w"]) : null;
        infoPtl.ville = (workSheet[("N" + i)]) ? workSheet[("N" + i)]["w"] : "";
        infoPtl.pays = (workSheet[("O" + i)]) ? workSheet[("O" + i)]["w"] : "";
        infoPtl.email = (workSheet[("P" + i)]) ? workSheet[("P" + i)]["w"] : "";
        infoPtl.telephone_fixe = (workSheet[("Q" + i)]) ? workSheet[("Q" + i)]["w"] : "";
        infoPtl.canal_vente = (workSheet[("R" + i)]) ? workSheet[("R" + i)]["w"] : "";

        //console.log((workSheet[("AA" + i)]) ? workSheet[("AA" + i)]["w"] : "Aucune valeur" );

        contenu.logo["url"] = (workSheet[("S" + i)]) ? workSheet[("S" + i)]["w"] : "";
        contenu.site_internet["url"] = (workSheet[("U" + i)]) ? workSheet[("U" + i)]["w"] : "";
        contenu.description = (workSheet[("W" + i)]) ? workSheet[("W" + i)]["w"] : "";
        


        if (workSheet[("Y" + i)]) {
          let distinct = this.distinguerLienEtPhoto(workSheet[("Y" + i)]["w"]);

          if(distinct.type === 0 && distinct.valeur !== "") {
            contenu.reseaux_sociaux.push({
              url : distinct.valeur,
              case : "Y"
            });
          } else if ( distinct.type === 1 && distinct.valeur !== "") {
            contenu.photo.push({
              url : distinct.valeur,
              case : "Y"
            });
          }
        }



        if (workSheet[("AA" + i)]) {
          let distinct = this.distinguerLienEtPhoto(workSheet[("AA" + i)]["w"]);

          if(distinct.type === 0 && distinct.valeur !== "") {
            contenu.reseaux_sociaux.push({
              url : distinct.valeur,
              case : "AA"
            });
          } else if ( distinct.type === 1 && distinct.valeur !== "") {
            contenu.photo.push({
              url : distinct.valeur,
              case : "AA"
            });
          }
        }

        if (workSheet[("AC" + i)]) {
          let distinct = this.distinguerLienEtPhoto(workSheet[("AC" + i)]["w"]);

          if(distinct.type === 0 && distinct.valeur !== "") {
            contenu.reseaux_sociaux.push({
              url : distinct.valeur,
              case : "AC"
            });
          } else if ( distinct.type === 1 && distinct.valeur !== "") {
            contenu.photo.push({
              url : distinct.valeur,
              case : "AC"
            });
          }
        }

        if (workSheet[("AE" + i)]) {
          let distinct = this.distinguerLienEtPhoto(workSheet[("AE" + i)]["w"]);

          if(distinct.type === 0 && distinct.valeur !== "") {
            contenu.reseaux_sociaux.push({
              url : distinct.valeur,
              case : "AE"
            });
          } else if ( distinct.type === 1 && distinct.valeur !== "") {
            contenu.photo.push({
              url : distinct.valeur,
              case : "AE"
            });
          }
        }

        if (workSheet[("AG" + i)]) {
          let distinct = this.distinguerLienEtPhoto(workSheet[("AG" + i)]["w"]);

          if(distinct.type === 0 && distinct.valeur !== "") {
            contenu.reseaux_sociaux.push({
              url : distinct.valeur,
              case : "AG"
            });
          } else if ( distinct.type === 1 && distinct.valeur !== "") {
            contenu.photo.push({
              url : distinct.valeur,
              case : "AG"
            });
          }
        }

        if (workSheet[("AI" + i)]) {
          let distinct = this.distinguerLienEtPhoto(workSheet[("AI" + i)]["w"]);

          if(distinct.type === 0 && distinct.valeur !== "") {
            contenu.reseaux_sociaux.push({
              url : distinct.valeur,
              case : "AI"
            });
          } else if ( distinct.type === 1 && distinct.valeur !== "") {
            contenu.photo.push({
              url : distinct.valeur,
              case : "AI"
            });
          }
        }

        if (workSheet[("AK" + i)]) {
          let distinct = this.distinguerLienEtPhoto(workSheet[("AK" + i)]["w"]);

          if(distinct.type === 0 && distinct.valeur !== "") {
            contenu.reseaux_sociaux.push({
              url : distinct.valeur,
              case : "AK"
            });
          } else if ( distinct.type === 1 && distinct.valeur !== "") {
            contenu.photo.push({
              url : distinct.valeur,
              case : "AK"
            });
          }
        }

        if (workSheet[("AM" + i)]) {
          let distinct = this.distinguerLienEtPhoto(workSheet[("AM" + i)]["w"]);

          if(distinct.type === 0 && distinct.valeur !== "") {
            contenu.reseaux_sociaux.push({
              url : distinct.valeur,
              case : "AM"
            });
          } else if ( distinct.type === 1 && distinct.valeur !== "") {
            contenu.photo.push({
              url : distinct.valeur,
              case : "AM"
            });
          }
        }

        if (workSheet[("AO" + i)]) {
          let distinct = this.distinguerLienEtPhoto(workSheet[("AO" + i)]["w"]);

          if(distinct.type === 0 && distinct.valeur !== "") {
            contenu.reseaux_sociaux.push({
              url : distinct.valeur,
              case : "AO"
            });
          } else if ( distinct.type === 1 && distinct.valeur !== "") {
            contenu.photo.push({
              url : distinct.valeur,
              case : "AO"
            });
          }
        }


        if (workSheet[("AQ" + i)]) {
          let distinct = this.distinguerLienEtPhoto(workSheet[("AQ" + i)]["w"]);

          if(distinct.type === 0 && distinct.valeur !== "") {
            contenu.reseaux_sociaux.push({
              url : distinct.valeur,
              case : "AQ"
            });
          } else if ( distinct.type === 1 && distinct.valeur !== "") {
            contenu.photo.push({
              url : distinct.valeur,
              case : "AQ"
            });
          }
        }

        if (workSheet[("AS" + i)]) {
          let distinct = this.distinguerLienEtPhoto(workSheet[("AS" + i)]["w"]);

          if(distinct.type === 0 && distinct.valeur !== "") {
            contenu.reseaux_sociaux.push({
              url : distinct.valeur,
              case : "AS"
            });
          } else if ( distinct.type === 1 && distinct.valeur !== "") {
            contenu.photo.push({
              url : distinct.valeur,
              case : "AS"
            });
          }
        }


        if (workSheet[("AU" + i)]) {
          let distinct = this.distinguerLienEtPhoto(workSheet[("AU" + i)]["w"]);

          if(distinct.type === 0 && distinct.valeur !== "") {
            contenu.reseaux_sociaux.push({
              url : distinct.valeur,
              case : "AU"
            });
          } else if ( distinct.type === 1 && distinct.valeur !== "") {
            contenu.photo.push({
              url : distinct.valeur,
              case : "AU"
            });
          }
        }


        if (workSheet[("AW" + i)]) {
          let distinct = this.distinguerLienEtPhoto(workSheet[("AW" + i)]["w"]);

          if(distinct.type === 0 && distinct.valeur !== "") {
            contenu.reseaux_sociaux.push({
              url : distinct.valeur,
              case : "AW"
            });
          } else if ( distinct.type === 1 && distinct.valeur !== "") {
            contenu.photo.push({
              url : distinct.valeur,
              case : "AW"
            });
          }
        }


        let ptl = {
          info_ptl : infoPtl,
          contenu : contenu
        };

        arrayOut.push(ptl);
      }

      //console.log(arrayOut[10])
      this.sendExcel(arrayOut, 0); // appel à une fonction récursive

    }
  }


  /**
   * Distingue le lien des photos => 0 pour lien et 1 pour photo et 2 pour autre(à ne pas intégrer)
   * @param lien 
   */
  distinguerLienEtPhoto(lien : string) { 
    let splitted  = lien.split('--');
    
    if(splitted[0] === "LRS") {
      return {
        type : 0,
        valeur : splitted[1]
      }
    } else if(splitted[0] === "PHOTO") {
      return {
        type : 1,
        valeur : splitted[1]
      }
    } else {
      return {
        type : 2,
        valeur : "CDV erreur dans le code"
      }
    }
  }

  convertToJSON(event) {
    let arrayOut = [];
    this.file = event.files[0];
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.file);

    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      let data = new Uint8Array(this.arrayBuffer);
      let arr = new Array();

      for(let i = 0; i != data.length; i++) arr[i] = String.fromCharCode(data[i]);

      let bstr = arr.join("");
      let workbook = XLSX.read(bstr, {type: "binary", cellDates:true, dateNF:"dd/mm/yyyy HH:MM:SS;@"});
      
      let firstSheetName = workbook.SheetNames[0];
      var workSheet = workbook.Sheets[firstSheetName];      


      let jsonOutput = XLSX.utils.sheet_to_json(workSheet, {raw: false, defval:""});
      //console.log(jsonOutput);

      jsonOutput.forEach( currentLine => {
        //console.log(currentLine['idPointAccueil']);
        //Object.keys(currentLine).map(k => console.log(k.trim()));
        
        let infoPtl = {
          "date_saisie": "",
          "numero_convention": "",
          "id_point_accueil": "",
          "id_shop": "",
          "produit": "",
          "enseigne": "",
          "activite_principale": "",
          "enseigne_guide": "",
          "adresse": "",
          "numero_voie": "",
          "complement_adresse": "",
          "bp": "",
          "code_postal": "",
          "ville": "",
          "pays": "",
          "email": "",
          "telephone_fixe": "",
          "telephone_portable": "",
          "canal_vente": ""
        };

        infoPtl["date_saisie"] = currentLine["Date Saisie PTL"];
        infoPtl["numero_convention"] = currentLine["Numéro convention ANCV"];
        infoPtl["id_point_accueil"] = currentLine["idPointAccueil"];
        infoPtl["id_shop"] = currentLine["shopID"];
        infoPtl["produit"] = currentLine["Produit"];
        infoPtl["enseigne"] = currentLine["Enseigne postale"];
        infoPtl["activite_principale"] = currentLine["Activité principale"];
        infoPtl["enseigne_guide"] = currentLine["Enseigne Guide"];
        infoPtl["adresse"] = currentLine["labelAdresse"];
        infoPtl["numero_voie"] = currentLine["Numéro et voie"];
        infoPtl["complement_adresse"] = currentLine["Complément adresse"];
        infoPtl["bp"] = currentLine["BP ou Lieu Dit"];
        infoPtl["code_postal"] = currentLine["Code Postal"];
        infoPtl["ville"] = currentLine["Ville"];
        infoPtl["pays"] = currentLine["Pays"];
        infoPtl["email"] = currentLine["Email"];
        infoPtl["telephone_fixe"] = currentLine["Telephone fixe"];
        infoPtl["telephone_portable"] = currentLine["Telephone portable"];
        infoPtl["canal_vente"] = currentLine["canal de vente"];


        let contenu = {
          "logo": {},
          "site_internet": {},
          "reseaux_sociaux": [],
          "photo": [],
          "description":""
        };

        contenu.logo["url"] = currentLine["Logo"];
        contenu.site_internet["url"] = currentLine["Site Internet"];

        //if(currentLine["Lien Reseau social 1"] && currentLine["Lien Reseau social 1"] !== "") {
          contenu.reseaux_sociaux.push({
            url : currentLine["Lien Reseau social 1"]
          });
        //}

        //if(currentLine["Lien Reseau social 2"] && currentLine["Lien Reseau social 2"] !== "") {
          contenu.reseaux_sociaux.push({
            url : currentLine["Lien Reseau social 2"]
          });
        //}
        

        //if(currentLine["Lien Reseau social 3"] && currentLine["Lien Reseau social 3"] !== "") {
          contenu.reseaux_sociaux.push({
            url : currentLine["Lien Reseau social 3"]
          });
        //}


        //if(currentLine["Lien Reseau social 4"] && currentLine["Lien Reseau social 4"] !== "") {
          contenu.reseaux_sociaux.push({
            url : currentLine["Lien Reseau social 4"]
          });
        //}

        //if(currentLine["Lien Reseau social 5"] && currentLine["Lien Reseau social 5"] !== "") {
          contenu.reseaux_sociaux.push({
            url : currentLine["Lien Reseau social 5"]
          });
        //}
        
        
        //if(currentLine["photo 1"] && currentLine["photo 1"] !== "") {
          contenu.photo.push({
            url : currentLine["photo 1"]            
          });
        //}

        //if(currentLine["photo 2"] && currentLine["photo 2"] !== "") {
          contenu.photo.push({
            url : currentLine["photo 2"]            
          });
        //}

        //if(currentLine["photo 3"] && currentLine["photo 3"] !== "") {
          contenu.photo.push({
            url : currentLine["photo 3"]            
          });
        //}


        contenu.description = currentLine["Description"];


        let ptl = {
          info_ptl : infoPtl,
          contenu : contenu
        };

        arrayOut.push(ptl);

      });

      //console.log(arrayOut);

      /* this.moderationService.sendExcel(arrayOut[21]).subscribe( value => {
        if(parseInt(value['statusCode']) !== 200) {
          console.log("erreur dans l'import excel");
        } else {
          console.log("success!!!")
        }
      }); */

      this.sendExcel(arrayOut, 0);

    }
  }


  sendExcel(arrayOut : any[], i: number) {
    this.moderationService.sendExcel(arrayOut[i]).subscribe( value => {
      if(parseInt(value['statusCode']) !== 200) {
        alert("erreur dans l'import excel, ligne numéro : " + (i+1));
        console.log(value);
      } 
        if(i < (arrayOut.length-1)) {
          this.sendExcel(arrayOut, (i+1));
        }else {
          alert("Import effectué avec succès");
        }
      
    });
  }


  async exportExcel() {
    this.moderationService.getFichesEnAttenteValidation().subscribe( async value => {
      if(value['status'] !== "success") {
        console.log("Une erreur dans la requête:" + value["cause"]);
      }  else if(value["data"].length < 1) {
        alert("rien à exporter");
      }
      else {
        let results = value['data'];
        const workbook = new Excel.Workbook();
        const sheet = workbook.addWorksheet("export");


        sheet.columns = [
          {header: 'Date saisie PTL', key: 'date_saisie'},
          {header: 'Numéro convention ANCV', key: 'numero_convention'},
          {header: 'idPoinAccueil', key: 'id_point_accueil'},
          {header: 'shopID', key: 'shop_id'},
          {header: 'Produit', key: 'produit'},
          {header: 'Enseigne postale', key: 'enseigne'},
          {header: 'Activité principale', key: 'activite_principale'},
          {header: 'Enseigne Guide', key: 'enseigne_guide'},
          {header: 'labelAdresse', key: 'adresse'},
          {header: 'Numéro et voie', key: 'numero_voie'},
          {header: 'Complément adresse', key: 'complement_adresse'},
          {header: 'BP ou Lieu Dit', key: 'bp'},
          {header: 'Code Postal', key: 'code_postal'},
          {header: 'Ville', key: 'ville'},
          {header: 'Pays', key: 'pays'},
          {header: 'Email', key: 'email'},
          {header: 'Telephone fixe', key: 'telephone_fixe'},
          {header: 'Telephone portable', key: 'telephone_portable'},
          {header: 'canal de vente', key: 'canal_vente'},
          {header: 'Logo', key: 'logo'},
          {header: 'photo 1', key: 'photo_1'},
          {header: 'photo 2', key: 'photo_2'},
          {header: 'photo 3', key: 'photo_3'},
          {header: 'Site Internet', key: 'site_internet'},
          {header: 'Lien Reseau social 1', key: 'rs_1'},
          {header: 'Lien Reseau social 2', key: 'rs_2'},
          {header: 'Lien Reseau social 3', key: 'rs_3'},
          {header: 'Lien Reseau social 4', key: 'rs_4'},
          {header: 'Lien Reseau social 5', key: 'rs_5'},
          {header: 'Description', key: 'description'},
          {header: 'Logo modéré', key: 'status_logo'},
          {header: 'photo 1 modéré', key: 'status_photo_1'},
          {header: 'photo 2 modéré', key: 'status_photo_2'},
          {header: 'photo 3 modéré', key: 'status_photo_3'},
          {header: 'Site Internet modéré', key: 'status_site_internet'},
          {header: 'Lien Reseau social 1 modéré', key: 'status_rs_1'},
          {header: 'Lien Reseau social 2 modéré', key: 'status_rs_2'},
          {header: 'Lien Reseau social 3 modéré', key: 'status_rs_3'},
          {header: 'Lien Reseau social 4 modéré', key: 'status_rs_4'},
          {header: 'Lien Reseau social 5 modéré', key: 'status_rs_5'},
          {header: 'Description modéré', key: 'status_description'},
          {header: 'Motif logo modéré', key: 'motif_logo'},
          {header: 'Motif photo 1 modéré', key: 'motif_photo_1'},
          {header: 'Motif photo 2 modéré', key: 'motif_photo_2'},
          {header: 'Motif photo 3 modéré', key: 'motif_photo_3'},
          {header: 'Motif Site Internet modéré', key: 'motif_site_internet'},
          {header: 'Motif Lien Reseau social 1 modéré', key: 'motif_rs_1'},
          {header: 'Motif Lien Reseau social 2 modéré', key: 'motif_rs_2'},
          {header: 'Motif Lien Reseau social 3 modéré', key: 'motif_rs_3'},
          {header: 'Motif Lien Reseau social 4 modéré', key: 'motif_rs_4'},
          {header: 'Motif Lien Reseau social 5 modéré', key: 'motif_rs_5'},
          {header: 'Motif Description modéré', key: 'motif_description'},
        ];
        
        sheet.getRow(0).eachCell( (cell, colNumber) => {
        sheet.getRow(0).getCell(colNumber).font = {name:'Arial', size: 4};
        sheet.getRow(0).getCell(colNumber).fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'17191a'},
            bgColor:{argb:'8db4e2'}
          };
          
        });
        
        

        results.forEach((currentModeration) => {
        
          //let currentRow = sheet.getRow(index);
          let contenus = currentModeration.contenus;
          let logo = {};
          let photos = [];
          let site = {};
          let rs = [];
          let description = {};

          contenus.forEach(currentContenu => {
            let formatedContenu = {};
            let erreurs = [];
            (currentContenu["erreurs"] !== undefined && currentContenu["erreurs"].length > 0 && currentContenu["erreurs"] !== null ) ? erreurs = currentContenu["erreurs"] : erreurs = [];


            formatedContenu["valeur"] = currentContenu["valeur_contenu"];
            formatedContenu["statut"] = (currentContenu["is_valid"]) ? 'OK' : 'KO';
            formatedContenu["motif"] = "";

            if(erreurs.length > 0 ) {
              let cumuledErreurs = "";
              erreurs.forEach( currentErreur => {
                (cumuledErreurs === "") ? cumuledErreurs = currentErreur.code_rejet : cumuledErreurs = cumuledErreurs + "|" + currentErreur.code_rejet;
              });

              formatedContenu["motif"] = cumuledErreurs;
            }       
            
            switch(currentContenu["designation_type"]) {

              case('logo') : {
                logo = formatedContenu;
                break;
              }

              case('lien site web') : {
                site = formatedContenu;
                break;
              }

              case('descriptif PTL') : {
                description = formatedContenu;
                break;
              }

              case('photo') : {
                photos.push(formatedContenu)
                break;
              }

              case('lien reseaux sociaux') : {
                rs.push(formatedContenu);
                break;
              }
            }
          });


          sheet.addRow( {
            date_saisie : currentModeration['date_saisie'],
            numero_convention : currentModeration["numero_convention"],
            id_point_accueil : currentModeration["id_point_accueil"],
            shop_id : currentModeration["shop_id"],
            produit : currentModeration["produit"],
            enseigne : currentModeration["enseigne"],
            activite_principale : currentModeration["activite_principale"],
            enseigne_guide : currentModeration.enseigne_guide,
            adresse : currentModeration.adresse,
            numero_voie : currentModeration.numero_voie,
            complement_adresse : currentModeration.complement_adresse,
            bp : currentModeration.bp,
            code_postal : currentModeration.code_postal,
            ville : currentModeration.ville,
            pays : currentModeration.pays,
            email : currentModeration.email,
            telephone_fixe : currentModeration.telephone_fixe,
            telephone_portable : currentModeration.telephone_portable,
            canal_vente : currentModeration.canal_vente,
            logo : (logo["valeur"]) ? logo["valeur"] : "",
            photo_1 : (photos[0]) ? photos[0]["valeur"] : "",
            photo_2 : (photos[1]) ? photos[1]["valeur"] : "",
            photo_3 : (photos[2]) ? photos[2]["valeur"] : "",
            site_internet : (site["valeur"]) ? site['valeur'] : "",
            rs_1 : (rs[0]) ? rs[0]["valeur"] : "",
            rs_2 : (rs[1]) ? rs[1]["valeur"] : "",
            rs_3 : (rs[2]) ? rs[2]["valeur"] : "",
            rs_4 : (rs[3]) ? rs[3]["valeur"] : "",
            rs_5 : (rs[4]) ? rs[4]["valeur"] : "",
            description : (description["valeur"]) ? description["valeur"] : "",
            status_logo : (logo["statut"]) ? logo["statut"] : "",
            status_photo_1 : (photos[0]) ? photos[0]["statut"] : "",
            status_photo_2 : (photos[1]) ? photos[1]["statut"] : "",
            status_photo_3 : (photos[2]) ? photos[2]["statut"] : "",
            status_site_internet : (site["statut"]) ? site['statut'] : "",
            status_rs_1 : (rs[0]) ? rs[0]["statut"] : "",
            status_rs_2 : (rs[1]) ? rs[1]["statut"] : "",
            status_rs_3 : (rs[2]) ? rs[2]["statut"] : "",
            status_rs_4 : (rs[3]) ? rs[3]["statut"] : "",
            status_rs_5 : (rs[4]) ? rs[4]["statut"] : "",
            status_description : (description["statut"]) ? description["statut"] : "",
            motif_logo : (logo["motif"]) ? logo["motif"] : "",
            motif_photo_1 : (photos[0]) ? photos[0]["motif"] : "",
            motif_photo_2 : (photos[1]) ? photos[1]["motif"] : "",
            motif_photo_3 : (photos[2]) ? photos[2]["motif"] : "",
            motif_site_internet : (site["motif"]) ? site['motif'] : "",
            motif_rs_1 : (rs[0]) ? rs[0]["motif"] : "",
            motif_rs_2 : (rs[1]) ? rs[1]["motif"] : "",
            motif_rs_3 : (rs[2]) ? rs[2]["motif"] : "",
            motif_rs_4 : (rs[3]) ? rs[3]["motif"] : "",
            motif_rs_5 : (rs[4]) ? rs[4]["motif"] : "",
            motif_description : (description["motif"]) ? description["motif"] : ""            
          }).commit();

        });

         await workbook.xlsx.writeBuffer({useStyles:true}).then( (buffer) => {
            FileSaver.saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'test.xlsx');
            let user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
            alert("Fichier exporté avec succès");
            results.forEach(element => {
              let parameter = {
                'idModeration' : element.id_moderation,
                'operateur' : user["matricule"],
                'action' : 11,
                'contenus' : element['contenus'],
                "duree" : 0,
                "is_ok" : true,
                "passe_cq" : false,
                "doute" : false
              }
              //let raw = String.raw`${JSON.stringify(parameter)}`;
        
              this.contenuService.validerTraitement(parameter).subscribe(value => {
                if(value["status"] !== "success"){
                  console.log("Une erreur dans la requête:" + value["cause"]);
                }else {
                  console.log('ok');
                }
              });
            });
            
      

          }).catch(err => {
           console.log(err);
           alert("erreur lors de la génération du fichier excel");
         })

      }
    });
  }


  exportExcelByCellRef() {
    this.moderationService.getFichesEnAttenteValidation().subscribe( async value => {
      if(value['status'] !== "success") {
        console.log("Une erreur dans la requête:" + value["cause"]);
      }  else if(value["data"].length < 1) {
        alert("rien à exporter");
      }
      else {
        let results = value['data'];
        //const workbook = new Excel.stream.xlsx.WorkbookWriter({useStyles : true, filename:'export.xlsx'});
        const workbook = new Excel.Workbook();
        const sheet = workbook.addWorksheet("export");

        console.log("nb : " + results.length);

        // set title
        sheet.getCell('A1').value = "Date Saisie PTL";
        sheet.getCell('B1').value = "Numéro convention ANCV";
        sheet.getCell('C1').value = "Login PTL";
        sheet.getCell('D1').value = "shopID";
        sheet.getCell('E1').value = "Produit";
        sheet.getCell('F1').value = "Enseigne postale";
        sheet.getCell('G1').value = "Activité principale";
        sheet.getCell('H1').value = "Enseigne Guide";
        sheet.getCell('I1').value = "labelAdresse";
        sheet.getCell('J1').value = "Numéro et voie";
        sheet.getCell('K1').value = "Complément adresse";
        sheet.getCell('L1').value = "BP ou Lieu Dit";
        sheet.getCell('M1').value = "Code Postal";
        sheet.getCell('N1').value = "Ville";
        sheet.getCell('O1').value = "Pays";
        sheet.getCell('P1').value = "Email";
        sheet.getCell('Q1').value = "Téléphone fixe";
        sheet.getCell('R1').value = "Téléphone portable";
        sheet.getCell('S1').value = "Logo";
        sheet.getCell('T1').value = "Résultat modération\nLogo\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('U1').value = "Site Internet";
        sheet.getCell('V1').value = "Résultat modération\nSite Internet\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('W1').value = "Description";
        sheet.getCell('X1').value = "Résultat modération\nDescription\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('Y1').value = "Canal de vente = CDV\nLRS = Lien réseau social\nPhoto = Photo";
        sheet.getCell('Z1').value = "Résultat modération\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('AA1').value = "Canal de vente = CDV\nLRS = Lien réseau social\nPhoto = Photo";
        sheet.getCell('AB1').value = "Résultat modération\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('AC1').value = "Canal de vente = CDV\nLRS = Lien réseau social\nPhoto = Photo";
        sheet.getCell('AD1').value = "Résultat modération\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('AE1').value = "Canal de vente = CDV\nLRS = Lien réseau social\nPhoto = Photo";
        sheet.getCell('AF1').value = "Résultat modération\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('AG1').value = "Canal de vente = CDV\nLRS = Lien réseau social\nPhoto = Photo";
        sheet.getCell('AH1').value = "Résultat modération\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('AI1').value = "Canal de vente = CDV\nLRS = Lien réseau social\nPhoto = Photo";
        sheet.getCell('AJ1').value = "Résultat modération\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('AK1').value = "Canal de vente = CDV\nLRS = Lien réseau social\nPhoto = Photo";
        sheet.getCell('AL1').value = "Résultat modération\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('AM1').value = "Canal de vente = CDV\nLRS = Lien réseau social\nPhoto = Photo";
        sheet.getCell('AN1').value = "Résultat modération\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('AO1').value = "Canal de vente = CDV\nLRS = Lien réseau social\nPhoto = Photo";
        sheet.getCell('AP1').value = "Résultat modération\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('AQ1').value = "Canal de vente = CDV\nLRS = Lien réseau social\nPhoto = Photo";
        sheet.getCell('AR1').value = "Résultat modération\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('AS1').value = "Canal de vente = CDV\nLRS = Lien réseau social\nPhoto = Photo";
        sheet.getCell('AT1').value = "Résultat modération\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('AU1').value = "Canal de vente = CDV\nLRS = Lien réseau social\nPhoto = Photo";
        sheet.getCell('AV1').value = "Résultat modération\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";
        sheet.getCell('AW1').value = "Canal de vente = CDV\nLRS = Lien réseau social\nPhoto = Photo";
        sheet.getCell('AX1').value = "Résultat modération\n(si OK >> mettre OK)\n(si KO >> mettre le contenu corrigé ou KO)";

        //=> styles des colonnes info       
        [
          'A1',
          'B1',
          'C1',
          'D1',
          'E1',
          'F1',
          'G1',
          'H1',
          'I1',
          'J1',
          'K1',
          'L1',
          'M1',
          'N1',
          'O1',
          'P1',
          'Q1',
          'R1',
          'S1',
          'U1',
          'W1',
          'Y1',
          'AA1',
          'AC1',
          'AE1',
          'AG1',
          'AI1',
          'AK1',
          'AM1',
          'AO1',
          'AQ1',
          'AS1',
          'AU1',
          'AW1',
        ].map(currentCell => {
          sheet.getCell(currentCell).fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'00ACB9CA'}
          };
          sheet.getCell(currentCell).alignment = {
            vertical : 'top',
            horizontal : 'left',
            wrapText : true
          };
        });


        //=> styles des colonnes réponses

        [
          'T1',
          'V1',
          'X1',
          'Z1',
          'AB1',
          'AD1',
          'AF1',
          'AH1',
          'AJ1',
          'AL1',
          'AN1',
          'AP1',
          'AR1',
          'AT1',
          'AV1',
          'AX1'
        ].map(currentCell => {
          sheet.getCell(currentCell).fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'00FFFF00'}
           };

           sheet.getCell(currentCell).alignment = {
             vertical : 'top',
             horizontal : 'left',
             wrapText : true
           };
        });


        sheet.getRow(1).height = 125;
         


        let i = 2;
        results.forEach( (currentModeration) => {
          
          let contenus = currentModeration.contenus;
          let logo = {};
          let photos = [];
          let site = {};
          let rs = [];
          let description = {};

          contenus.forEach(currentContenu => {
            let formatedContenu = {};
            let erreurs = [];
            let caseExcel = "";
            (currentContenu["erreurs"] !== undefined && currentContenu["erreurs"].length > 0 && currentContenu["erreurs"] !== null ) ? erreurs = currentContenu["erreurs"] : erreurs = [];
            (currentContenu["case_excel"] !== undefined && currentContenu["case_excel"] !== "" && currentContenu["case_excel"] !== null ) ? caseExcel = currentContenu["case_excel"] : caseExcel = "";

            formatedContenu["valeur"] = currentContenu["valeur_contenu"];
            formatedContenu["statut"] = (currentContenu["is_valid"]) ? 'OK' : 'KO';
            formatedContenu["motif"] = "";
            formatedContenu["case_excel"] = caseExcel;

            if(erreurs.length > 0 ) {
              let cumuledErreurs = "";
              erreurs.forEach( currentErreur => {
                (cumuledErreurs === "") ? cumuledErreurs = currentErreur.code_rejet : cumuledErreurs = cumuledErreurs + "|" + currentErreur.code_rejet;
              });

              formatedContenu["motif"] = cumuledErreurs;
            }       
            
            switch(currentContenu["designation_type"]) {

              case('logo') : {
                logo = formatedContenu;
                break;
              }

              case('lien site web') : {
                site = formatedContenu;
                break;
              }

              case('descriptif PTL') : {
                description = formatedContenu;
                break;
              }

              case('photo') : {
                photos.push(formatedContenu)
                break;
              }

              case('lien reseaux sociaux') : {
                rs.push(formatedContenu);
                break;
              }
            }
          });

          //=> Ajout valeurs fixes
          sheet.getCell('A' + i).value = currentModeration['date_saisie'];
          sheet.getCell('B' + i).value = currentModeration["numero_convention"];
          sheet.getCell('C' + i).value = currentModeration["login_ptl"];
          sheet.getCell('D' + i).value = currentModeration["shop_id"];
          sheet.getCell('E' + i).value = currentModeration["produit"];
          sheet.getCell('F' + i).value = currentModeration["enseigne"];
          sheet.getCell('G' + i).value = currentModeration["activite_principale"];
          sheet.getCell('H' + i).value = currentModeration.enseigne_guide;
          sheet.getCell('I' + i).value = currentModeration.adresse;
          sheet.getCell('J' + i).value = currentModeration.numero_voie;
          sheet.getCell('K' + i).value = currentModeration.complement_adresse;
          sheet.getCell('L' + i).value = currentModeration.bp;
          sheet.getCell('M' + i).value = currentModeration.code_postal;
          sheet.getCell('N' + i).value = currentModeration.ville;
          sheet.getCell('O' + i).value = currentModeration.pays;
          sheet.getCell('P' + i).value = currentModeration.email;
          sheet.getCell('Q' + i).value = currentModeration.telephone_fixe;
          sheet.getCell('R' + i).value = currentModeration.telephone_portable;

          // => Ajout valeurs contenus
          if(logo !== {} && logo !== undefined && logo["valeur"]) {
            sheet.getCell('S' + i).value = logo["valeur"];
            sheet.getCell('T' + i).value = (logo["statut"] === "OK") ? logo["statut"] : logo["statut"] + " ===> " + logo['motif'];
          } 
          
          if(site !== {} && site !== undefined && site["valeur"]) {
            sheet.getCell('U' + i).value = site["valeur"];
            sheet.getCell('V' + i).value = (site["statut"] === "OK") ? site["statut"] : site["statut"] + " ===> " + site['motif'];
          }

          console.log(description);
          if(description !== {} && description !== undefined && description["valeur"]) {
            sheet.getCell('W' + i).value = description["valeur"];
            sheet.getCell('X' + i).value = (description["statut"] === "OK") ? description["statut"] : description["statut"] + " ===> " + description['motif'];
          }


          if(photos.length > 0) {
            photos.forEach( currentPhoto => {
              let cell = currentPhoto["case_excel"];
              if(cell !== "") {
                let statusCell = this.getMotifCell(cell);
                sheet.getCell(cell + "" + i).value = "PHOTO--" + currentPhoto["valeur"];
                sheet.getCell(statusCell + "" + i).value = (currentPhoto["statut"] === "OK") ? currentPhoto["statut"] : currentPhoto["statut"] + " ===> " + currentPhoto['motif'];;
              }
            });
          }


          if(rs.length > 0) {
            rs.forEach( currentRs => {
              let cell = currentRs["case_excel"];
              if(cell !== "") {
                let statusCell = this.getMotifCell(cell);
                sheet.getCell(cell + "" + i).value = "LRS--" + currentRs["valeur"];
                sheet.getCell(statusCell + "" + i).value = (currentRs["statut"] === "OK") ? currentRs["statut"] : currentRs["statut"] + " ===> " + currentRs['motif'];
              }
            });
          }



          i++
        }); //=> fin boucle forEach moderation


        await workbook.xlsx.writeBuffer({useStyles:true}).then( (buffer) => {
          FileSaver.saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'test.xlsx');
          let user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
          alert("Fichier exporté avec succès");
          results.forEach(element => {

            let contenus = element.contenus;
            let isOk = true;
            
            if(contenus.length === 0) {
              isOk = false;
            } else {
              contenus.forEach(current => {
                if(current["erreurs"] !== undefined && current["erreurs"].length > 0 && current["erreurs"] !== null) {
                  isOk = false;
                }
              });
            }


            let parameter = {
              'idModeration' : element.id_moderation,
              'operateur' : user["matricule"],
              'action' : 11,
              'contenus' : element['contenus'],
              "duree" : 0,
              "is_ok" : isOk,
              "passe_cq" : false,
              "doute" : false,
              "etat" : 5
            }
            //let raw = String.raw`${JSON.stringify(parameter)}`;
      
            this.contenuService.validerTraitement(parameter).subscribe(value => {
              if(value["status"] !== "success"){
                console.log("Une erreur dans la requête:" + value["cause"]);
              }else {
                console.log('ok ==> ' + results.length);
              }
            });
          });
          

        }).catch(err => {
          console.log(err);
          alert("erreur lors de la génération du fichier excel");
        });

      }
    });
  }



  getMotifCell(cell : string) {
    if(cell === "AA") {
      return "AB";
    } else if(cell === "AC") {
      return "AD";
    } else if(cell === "AE") {
      return "AF";
    } else if(cell === "AG") {
      return "AH"
    } else if(cell === "AI") {
      return "AJ";
    } else if(cell === "AK") {
      return "AL";
    } else if(cell === "AM") {
      return "AN";
    } else if(cell === "AO") {
      return "AP";
    } else if(cell === "AQ") {
      return "AR";
    } else if(cell === "AS") {
      return "AT";
    } else if(cell === "AU") {
      return "AV";
    } else if(cell === "AW") {
      return "AX";
    } else if(cell === "Y") {
      return "Z;"
    }
  }

}
